import React from 'react';

import { Group, Text, TextProps, useMantineTheme } from '@mantine/core';
import { IconInfoSquareRounded } from '@tabler/icons-react';
import KiloActionIcon from 'components/KiloActionIcon';
import KiloTooltip, { PACKAGE_TYPE_TOOLTIP_MESSAGES } from 'components/KiloTooltip';
import { PackageTypeLabelsEnum, PackageTypeShortLabelsEnum } from 'types/enums';
import { Package } from 'types/generated';

interface IPackageTypeLabelProps extends TextProps {
  type: Package['type'];
  short?: boolean;
}

/** A package type label with a tooltip explaining how that type renews. */
const PackageTypeLabel = ({ type, short = false, ...textProps }: IPackageTypeLabelProps): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Group spacing={4} noWrap>
      <Text {...textProps}>{short ? PackageTypeShortLabelsEnum[type] : PackageTypeLabelsEnum[type]}</Text>
      <KiloTooltip label={PACKAGE_TYPE_TOOLTIP_MESSAGES[type]} multiline width={240} withinPortal>
        <KiloActionIcon
          variant='subtle'
          size='xs'
          aria-label={PACKAGE_TYPE_TOOLTIP_MESSAGES[type]}
          onClick={event => event.stopPropagation()}
          data-cy={`packageTypeTooltip-${type}`}
        >
          <IconInfoSquareRounded size='1rem' color={theme.colors.gray[6]} />
        </KiloActionIcon>
      </KiloTooltip>
    </Group>
  );
};

export default PackageTypeLabel;
